import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    height: 300,
    width: 400,
  },
  paper: {
    margin: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    msTransform: 'translate(-50%, -50%)',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  close: {
    position: 'absolute',
    right: '5px',
    top: '5px',
    padding: '1px 6px',
    cursor: 'pointer',
  },
}));

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function UploadCompleteModal({ open, imageCount, handleClose }) {
  const classes = useStyles();
  console.log('[i] open: ', open);

  return (
    <div>
      <Modal
        open={open === true ? true : false}
        onClose={handleClose}
        aria-labelledby="upload-complete-modal-title"
        aria-describedby="upload-complete-modal-description"
      >
        <div className={classes.paper}>
          <span onClick={handleClose} className={classes.close}>
            x
          </span>
          <div id="upload-complete-modal-description">
            <p>
              <FormControlLabel
                control={<GreenCheckbox checked={true} name="checkedG" />}
                label={Number.isInteger(imageCount) ? imageCount + ' Images Uploaded!' : ' Images Uploaded!'}
              />
            </p>
            <p>Thank you for submitting your images. </p>
            <p>Our team will review everything and reach out if needed. </p>
          </div>
        </div>
      </Modal>
    </div>
  );
}
